export const currencyMap = Object.freeze({
  "RON": "lei",
  "EUR": "€"
});

